import { apiClient } from '../apiClient';

export type ApiNotificationType =
  | 'DUPLICATED'
  | 'SCORED'
  | 'INTERVIEW_CREATED'
  | 'INTERVIEW_REMINDER'
  | 'CV_REVIEW_REQUESTED'
  | 'CV_EVALUATED';

export type NotificationListQuery = {
  unread_only?: boolean;
  page?: number;
  page_size?: number;
};

export type ApiNotification = {
  id: string;
  type: ApiNotificationType;
  title: string;
  message: string;
  application_id?: string | null;
  is_read: boolean;
  created_at: string;
  read_at?: string | null;
};

export type NotificationListResponse = {
  items: ApiNotification[];
  pagination: {
    page: number;
    page_size: number;
    total: number;
  };
  unread_count: number;
};

export type MarkAllNotificationsReadResponse = {
  unread_count: number;
  updated_count: number;
};

export const listNotifications = (params?: NotificationListQuery) =>
  apiClient.get<NotificationListResponse>('/notifications', params);

export const markNotificationRead = (notificationId: string) =>
  apiClient.post<ApiNotification>(`/notifications/${notificationId}/read`);

export const markAllNotificationsRead = () =>
  apiClient.post<MarkAllNotificationsReadResponse>('/notifications/read-all');
